var _path, _polygon, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.91,445.21s0-.09,0-.24l0-.66c0-.6,0-1.45,0-2.53,0-2.22,0-5.42-.09-9.45l.15.16-48.65.09.25-.25h0v6.53c0,2.15,0,4.27,0,6.34l-.24-.25,34.67.11,10.24.07,2.76,0,.73,0,.25,0h-.22l-.7,0-2.71,0-10.18.07-34.84.11H78v-.24c0-2.07,0-4.19,0-6.34v-6.53h0l.25-.24,48.65.09h.15v.15c0,4.07-.06,7.3-.08,9.54,0,1.07,0,1.9,0,2.5V445A.85.85,0,0,1,126.91,445.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.51,432.33a1.1,1.1,0,0,1,0-.24c0-.19,0-.41,0-.68l0-2.58c0-2.26-.06-5.45-.1-9.37l.18.18-29.23.07c-.22.22.3-.3.24-.25h0v6.62q0,3.24,0,6.24l-.23-.23,20.91.11,6.09.07,1.64,0,.59,0a3.28,3.28,0,0,1-.53,0l-1.6,0-6,.07-21.07.11H104v-.24q0-3,0-6.24v-6.62h0c-.06.06.47-.47.25-.24l29.23.07h.18v.17c0,4-.08,7.19-.1,9.48,0,1.06,0,1.91,0,2.54S133.52,432.35,133.51,432.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.48,
    y: 39,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.56,65.43s0-.09,0-.24l0-.66c0-.6,0-1.45,0-2.53,0-2.22,0-5.42-.09-9.44l.15.15-48.65.09c.11-.11-.25.25.25-.24h0V59.1c0,2.14,0,4.26,0,6.33l-.24-.24,34.67.11,10.24.06,2.76,0h.73a1.27,1.27,0,0,1,.25,0h-.22l-.7,0-2.71,0-10.18.07-34.84.11h-.24v-.24c0-2.07,0-4.19,0-6.33V52.58h0l.25-.25,48.65.1h.16v.15c0,4.06-.06,7.29-.08,9.53,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.63A.85.85,0,0,1,125.56,65.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.88,75a1,1,0,0,1,0-.23c0-.17,0-.39,0-.66,0-.61,0-1.45,0-2.53,0-2.22-.05-5.42-.08-9.45l.15.15-48.65.1c.11-.11-.25.25.24-.25h0V75l-.24-.24,34.67.11,10.23.07,2.77,0,.72,0h.26l-.23,0L449,75l-2.72,0-10.17.07-34.84.11H401V62.12h0c.49-.49.14-.13.25-.24l48.65.09H450v.15c0,4.07-.06,7.29-.08,9.54,0,1.07,0,1.9,0,2.5l0,.63A1.23,1.23,0,0,1,449.88,75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.47,62.11s0-.09,0-.24,0-.41,0-.68c0-.64,0-1.5-.05-2.58,0-2.26-.05-5.45-.09-9.37l.17.18-29.23.07.25-.25h0v6.62q0,3.24,0,6.24l-.24-.23,20.91.11,6.1.06,1.64,0,.58,0a3.28,3.28,0,0,1-.53,0l-1.59,0-6,.07-21.07.11H427v-.24q0-3,0-6.24V49.25h0c-.05.06.48-.47.25-.25l29.23.07h.18v.18c0,4-.07,7.19-.09,9.47,0,1.07,0,1.92-.05,2.54A4.76,4.76,0,0,1,456.47,62.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.15,195.51a2.07,2.07,0,0,1,0-.23l0-.66c0-.61,0-1.45,0-2.53,0-2.22,0-5.42-.08-9.45l.15.15-48.65.1.25-.25h0v6.53q0,3.23,0,6.33l-.24-.24,34.67.11,10.23.07,2.77,0,.73,0h.25s-.07,0-.22,0l-.7,0-2.71,0-10.18.07-34.84.11h-.24v-.25c0-2.07,0-4.18,0-6.33v-6.53h0c.5-.49.14-.13.25-.24l48.65.09h.15v.15c0,4.07-.06,7.29-.08,9.54,0,1.07,0,1.9,0,2.5v.63C75.16,195.45,75.16,195.52,75.15,195.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75,182.64a1.22,1.22,0,0,1,0-.24c0-.19,0-.41,0-.68,0-.64,0-1.5,0-2.58,0-2.26-.06-5.45-.1-9.37l.18.18L52.52,170c-.22.22.3-.3.24-.25h0v6.62q0,3.24,0,6.24l-.23-.23,20.91.11,6.09.06,1.64,0,.59,0a3.28,3.28,0,0,1-.53,0l-1.6,0-6,.07-21.07.11h-.24v-.24c0-2,0-4.08,0-6.24v-6.62h0l.25-.25,29.23.07h.18v.18c0,4-.08,7.19-.1,9.47,0,1.07,0,1.92,0,2.54S81.76,182.66,81.75,182.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.67,383a30.06,30.06,0,0,0-12.84-4.42c-2.1-.21-4.39-.15-6.08,1.12a1.26,1.26,0,0,0-.62,1.11,1.38,1.38,0,0,0,.59.76A18.37,18.37,0,0,0,399.67,383",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.34,382.6a62,62,0,0,1-8.29-7.3,20.82,20.82,0,0,1-5.2-9.62,3.81,3.81,0,0,1,.41-3.21c6.61,5.16,11.8,11.84,13.08,20.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.6,382.91a30.19,30.19,0,0,1,.16-10.89,14.68,14.68,0,0,1,5.8-9c1.14,2.67.65,5.74-.16,8.53a41.23,41.23,0,0,1-5.75,12.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.08,394.53a18.88,18.88,0,0,0-10.29,5.21,19.5,19.5,0,0,0-5.9,10.11c3.86-.24,7.14-3,9.51-6s4-6.4,6.63-9.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.49,396.38a25.37,25.37,0,0,1,2.94-24c2.24,8,1.41,17-2.94,24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.06,406.58a18.35,18.35,0,0,0-17.57,10.11c-.21.44-.41,1-.11,1.38a1.28,1.28,0,0,0,1.16.34c3.46-.22,6.53-2.31,9.06-4.68s4.74-5.11,7.53-7.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.78,406a32.76,32.76,0,0,1-.32-18.28c.64-2.35,1.72-4.82,3.9-5.93a.74.74,0,0,1,.59-.1.8.8,0,0,1,.38.43,11.09,11.09,0,0,1,.92,5.25,32.81,32.81,0,0,1-.82,5.3c-.69,3.25-1.05,6.73-2.83,9.53a20,20,0,0,0-1.13,2.09c-.34.71-.34,1-.65,1.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.45,409.4A23.58,23.58,0,0,1,442.58,390c.3-.38.69-.8,1.17-.75.75.07.94,1.05.9,1.8a34.91,34.91,0,0,1-6.2,18.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.5,410.8a28.17,28.17,0,0,0,23.12-4.7,18.71,18.71,0,0,0-12.52-1.54c-4.18,1-8,2.83-10.6,6.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.22,406.55a26.72,26.72,0,0,1,21-12.14c-.95,3.38-3.73,6-6.86,7.59A38,38,0,0,1,446.27,405c-1.34.26-3.18.54-4,1.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.88,385.91a61.49,61.49,0,0,0,2.69-12.29,20.52,20.52,0,0,0-2.45-12.16c-4.06,7.86-4.47,17-.36,24.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.55,379c4.75-8.63,14.44-15.53,24.24-16.49C473,371.92,462.7,379.2,452.55,379",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.57,380.69c7.08,1.08,13.11,5.6,19.73,8.34a8.91,8.91,0,0,0,4.46.86,3.5,3.5,0,0,0,2.19-6.18,9.6,9.6,0,0,0-3.24-2c-7.21-3-14.94-3.07-22.53-1.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.47,385.65c1.6.46,2.15,1.29,3.42,2.37a36.85,36.85,0,0,0,15,7.69c.58.14,1.33.2,1.61-.32s-.07-1-.39-1.4a20.7,20.7,0,0,0-9-6.13c-3.46-1.29-6.45-2.84-10.57-2.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.84,355.66A28.34,28.34,0,0,0,462.56,363a1.47,1.47,0,0,0,1-.35c.55-.6-.1-1.51-.74-2-6.38-5-14.12-7-22-5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.33,353.65a30.24,30.24,0,0,1,27.09-4.47,21.56,21.56,0,0,1-12.91,5.67,41.1,41.1,0,0,1-14.18-1.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.15,339.86c-.63-6.37-.22-11.4-.66-17.8,0-.51-.15-1.12-.63-1.31-.66-.26-1.22.56-1.44,1.24a20.42,20.42,0,0,0,2.72,17.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.69,340.57a37.34,37.34,0,0,0,10.55-10.26c2.09-2.85,3.85-6.27,3.37-9.77a10.09,10.09,0,0,0-7.61,3.78,21.3,21.3,0,0,0-3.88,7.81c-.85,2.8-1.44,5.68-2.43,8.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.06,337.69a85.06,85.06,0,0,0,26-15.32c-3.1-1.25-6.65-.5-9.75.75a30.78,30.78,0,0,0-16.36,14.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.61,344.05a52.37,52.37,0,0,0,14.42.07c4.67-.78,9.09-2.63,13.46-4.47a1.58,1.58,0,0,0,.92-.69,1.08,1.08,0,0,0-.33-1.16,2.82,2.82,0,0,0-1.15-.53c-4.75-1.33-9.88-.71-14.55.86a67.58,67.58,0,0,0-12.77,5.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.23,355.87a25.53,25.53,0,0,1-.24-21.11c2,3,2.24,6.89,1.87,10.5s-1.46,7.32-1.53,10.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.16,349.28a29.48,29.48,0,0,0-21.88,9.32,20.46,20.46,0,0,0,12-2.22,61.12,61.12,0,0,0,10.27-6.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.37,346.34c-4-.32-7.84-.81-11.68.36a14,14,0,0,0-8.9,7.55,21,21,0,0,0,10.95-2.07,62.23,62.23,0,0,0,9.63-5.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.38,346.48c-3.59-2.36-7.28-4.75-11.47-5.73s-9-.26-12,2.9c3.39,2,7.5,2.22,11.42,2.22s8.75-.05,12.45,1.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.4,346.67c-6.14-6-8.47-16.88-6-25.12a38.27,38.27,0,0,1,6,25.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.3,329.57c1.16-2.69,2-5.52,3-8.26a23.91,23.91,0,0,1,4.3-7.62,11.34,11.34,0,0,1,7.61-3.95,30.61,30.61,0,0,1-14.77,19.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.24,333.13c-1.91-2.64-4.13-6.22-6.73-8.19s-6-3.16-9.16-2.41a21.32,21.32,0,0,0,15.89,10.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.85,329.79a45.92,45.92,0,0,1-3-9.82,15.28,15.28,0,0,1,1.54-10c3.37,6.38,4.46,13.22,1.67,19.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.33,310c1.91-6.32,7.7-11,13.95-13.11a5.14,5.14,0,0,1,2.44-.36,2.11,2.11,0,0,1,1.81,1.5c.22,1.07-.66,2-1.5,2.75a47.54,47.54,0,0,1-16.7,9.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.4,304.82c.24-4.07.5-8.21,1.82-12.07s3.88-7.48,7.6-9.17c.63,4.11-1.18,8.21-3.37,11.75s-4.83,6.89-6.15,10.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.3,307.63c-1.58-4.61-1.74-10.46-4.5-14.47-1.93-2.81-5-4.72-6.68-7.69a11.74,11.74,0,0,0,.39,8.73,25.23,25.23,0,0,0,5.1,7.3c2,2.18,3.79,3.82,5.69,6.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.33,443.29c-.12,0-.23-30.73-.24-68.63s.09-68.64.21-68.64.23,30.73.24,68.64S427.45,443.29,427.33,443.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.19,351.24a7.3,7.3,0,0,1-1.16.43l-3.18,1.07c-2.68.92-6.36,2.24-10.36,3.88s-7.69,3.07-9.82,4.92a7.18,7.18,0,0,0-2,2.6c-.3.73-.36,1.17-.4,1.16a1.11,1.11,0,0,1,0-.32,5.14,5.14,0,0,1,.23-.9,6.92,6.92,0,0,1,1.92-2.78,17.6,17.6,0,0,1,4.26-2.65c1.71-.79,3.6-1.62,5.6-2.44,4-1.65,7.72-2.93,10.43-3.77,1.36-.42,2.46-.73,3.23-.94A6,6,0,0,1,454.19,351.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,329.61s-.1.14-.33.35l-1,.93L458,334.23l-12.26,10.91c-4.78,4.26-8.91,8.33-11.78,11.39-1.43,1.53-2.56,2.8-3.33,3.68l-.89,1a1.93,1.93,0,0,1-.33.33s.08-.14.26-.39.46-.61.83-1.07c.73-.92,1.82-2.22,3.23-3.78a155.2,155.2,0,0,1,11.72-11.51c4.8-4.25,9.17-8.06,12.34-10.81l3.77-3.24,1.05-.87A2.33,2.33,0,0,1,463,329.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,349.47c-.12-.06.88-2.36,1.87-5.28s1.48-5.38,1.61-5.36a18.23,18.23,0,0,1-1.19,5.5,33.94,33.94,0,0,1-1.49,3.69A5.39,5.39,0,0,1,440.58,349.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.36,368.07a5,5,0,0,1-.74-.86l-1.89-2.42c-1.58-2.05-3.77-4.88-6.23-8s-4.72-5.88-6.36-7.89l-1.93-2.39a5.64,5.64,0,0,1-.66-.91,6.63,6.63,0,0,1,.8.8c.49.53,1.18,1.32,2,2.3,1.7,2,4,4.71,6.47,7.81s4.61,6,6.14,8.06c.76,1,1.36,1.91,1.77,2.51A5.78,5.78,0,0,1,427.36,368.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.47,360.51a10.94,10.94,0,0,1-2.47-4.62,13.14,13.14,0,0,1-.55-4.65h.19c-.09.36-.15.55-.19.54s0-.2,0-.57l.19,0a21.27,21.27,0,0,0,.79,4.53A35.17,35.17,0,0,0,421.47,360.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.87,351a7.67,7.67,0,0,0-1.72-1,11.31,11.31,0,0,0-4.78-.38,30.64,30.64,0,0,0-4.82.77,14.19,14.19,0,0,1-2,.48,7.29,7.29,0,0,1,1.9-.78,22.38,22.38,0,0,1,4.86-.92,10.53,10.53,0,0,1,4.94.54A3,3,0,0,1,413.87,351Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.07,348.63c0,.07-1-.4-2.64-1a26.35,26.35,0,0,0-13.3-1c-1.7.3-2.73.62-2.75.55a2.3,2.3,0,0,1,.7-.3,16.19,16.19,0,0,1,2-.56,23.51,23.51,0,0,1,6.81-.48,23.85,23.85,0,0,1,6.66,1.5,16.4,16.4,0,0,1,1.88.86A2.52,2.52,0,0,1,412.07,348.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.3,338.83a53.94,53.94,0,0,1-1.92-6.68,54.1,54.1,0,0,1-1.5-6.8,107.3,107.3,0,0,1,3.42,13.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.42,338.83a30.53,30.53,0,0,0-2.13-4,17.27,17.27,0,0,0-3.14-3.24,2.81,2.81,0,0,1,1.21.62,10,10,0,0,1,2.29,2.36A8.75,8.75,0,0,1,427.42,338.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.33,426.91c-.05,0-.14-.74-.48-2.05a29.83,29.83,0,0,0-2.06-5.32,73.39,73.39,0,0,0-10.89-15.35c-2.43-2.78-4.79-5.4-6.8-7.91a56.62,56.62,0,0,1-4.86-7,34.28,34.28,0,0,1-2.45-5.2c-.23-.64-.39-1.14-.48-1.49a2.73,2.73,0,0,1-.13-.53s.27.71.77,2a38.68,38.68,0,0,0,2.56,5.1,59.06,59.06,0,0,0,4.91,6.91c2,2.49,4.38,5.1,6.81,7.88a69.9,69.9,0,0,1,10.85,15.51,26.12,26.12,0,0,1,1.93,5.41,15.62,15.62,0,0,1,.28,1.54A2.27,2.27,0,0,1,427.33,426.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.6,399.5a14.16,14.16,0,0,1-1.27.71,28,28,0,0,0-3.3,2.18,38,38,0,0,0-4.33,3.95c-1.53,1.61-3.09,3.47-4.69,5.47-3.2,4-6.19,7.56-8,10.4-.9,1.4-1.57,2.58-2,3.42a11.66,11.66,0,0,1-.7,1.28,1.48,1.48,0,0,1,.12-.36c.09-.23.22-.58.43-1a30.59,30.59,0,0,1,1.89-3.51,114.31,114.31,0,0,1,7.89-10.5c1.61-2,3.19-3.88,4.74-5.48a34.48,34.48,0,0,1,4.44-3.92,22,22,0,0,1,3.41-2.08c.42-.21.76-.34,1-.44S451.59,399.48,451.6,399.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.07,408.39a18.88,18.88,0,0,1-2.69.39A35.44,35.44,0,0,0,443,410a19.2,19.2,0,0,0-5.71,3c-1.31,1-1.93,1.86-2,1.81a2,2,0,0,1,.4-.62,10,10,0,0,1,1.4-1.43,17.26,17.26,0,0,1,5.77-3.18,28.66,28.66,0,0,1,6.48-1.14A14.87,14.87,0,0,1,452.07,408.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.09,413.86c-.14-.08,1.07-1.93,2-4.42s1.09-4.71,1.25-4.68a4.59,4.59,0,0,1-.05,1.44,15.66,15.66,0,0,1-.78,3.4,16.85,16.85,0,0,1-1.56,3.11A4.32,4.32,0,0,1,436.09,413.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.46,375.62a1.79,1.79,0,0,1-.43.23l-1.27.58c-.55.24-1.22.54-2,.94s-1.64.79-2.57,1.34l-1.46.84c-.51.29-1,.64-1.55,1-1.08.66-2.16,1.47-3.32,2.29A57.37,57.37,0,0,0,434.09,396c-.78,1.19-1.55,2.3-2.17,3.4-.32.55-.65,1.06-.92,1.58l-.78,1.49c-.53.94-.9,1.84-1.27,2.62s-.65,1.45-.86,2l-.53,1.28a2,2,0,0,1-.22.44,2.15,2.15,0,0,1,.13-.47l.45-1.31a21.37,21.37,0,0,1,.81-2.05c.34-.79.7-1.7,1.21-2.66.24-.48.49-1,.76-1.51s.59-1.05.9-1.61c.61-1.12,1.38-2.24,2.16-3.44a60.19,60.19,0,0,1,5.87-7.21,58.85,58.85,0,0,1,7-6.12c1.17-.82,2.27-1.62,3.36-2.27.55-.33,1.06-.67,1.57-1l1.49-.81c.94-.54,1.84-.93,2.62-1.3a20.8,20.8,0,0,1,2-.87l1.29-.5A2.41,2.41,0,0,1,459.46,375.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.25,388.49a3.15,3.15,0,0,1,1.06-1.57,6.63,6.63,0,0,1,4.25-1.63,11.7,11.7,0,0,1,4.48.87,6.15,6.15,0,0,1,1.69.83,11.53,11.53,0,0,1-1.79-.53,13.3,13.3,0,0,0-4.36-.73,6.93,6.93,0,0,0-4.07,1.43A13.61,13.61,0,0,0,440.25,388.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.38,391.45a15.78,15.78,0,0,0,1.21-3.93,16.52,16.52,0,0,0-.27-4.1,2.62,2.62,0,0,1,.5,1.15,8.15,8.15,0,0,1-.69,5.89C437.76,391.13,437.42,391.49,437.38,391.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.11,431.31c.66,11.74,4.2,23.69,9.64,35.76h23.67c5.19-11.95,8.49-23.88,9.07-35.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.66,450.31c0,.13-7.8.22-17.41.22s-17.4-.09-17.4-.22,7.79-.22,17.4-.22S444.66,450.19,444.66,450.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.13,454.57c0,.12-7.31.22-16.32.22s-16.32-.1-16.32-.22,7.31-.22,16.32-.22S444.13,454.44,444.13,454.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.13,439a64.69,64.69,0,0,1,0,10.9,67.62,67.62,0,0,1,0-10.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.82,439a72.53,72.53,0,0,1,0,11.29,69.39,69.39,0,0,1,0-11.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.72,438.92a75.51,75.51,0,0,1,0,11.52,75.51,75.51,0,0,1,0-11.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.74,439c0,.12-9.14.22-20.41.22s-20.42-.1-20.42-.22,9.14-.22,20.42-.22S447.74,438.9,447.74,439Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.77,467.07c0,.15-97.95.26-218.76.26s-218.78-.11-218.78-.26,97.93-.26,218.78-.26S464.77,466.93,464.77,467.07Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Door--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.14,
    y: 82.16,
    width: 190.81,
    height: 384.91,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,82.16c0,2.27.1,160.32.24,384.91v.25H176.88v-.26c0-148.64.05-284.11.06-384.91V82h.2L368,82.16l-190.81.2.19-.2c0,100.8,0,236.27.07,384.91l-.26-.26h0l190.78,0-.25.24C367.84,242.48,368,84.43,368,82.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.03,
    y: 99.83,
    width: 155.76,
    height: 367.24,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.03 467.07 318.08 445.25 318.08 99.83 195.03 99.83 195.03 467.07",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.8 467.07 305.92 445.25 350.79 445.25 350.79 467.07 196.8 467.07",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.54,289.17h0a2.42,2.42,0,0,1-2.42-2.42V256.48a2.42,2.42,0,0,1,2.42-2.42h0a2.42,2.42,0,0,1,2.42,2.42v30.27A2.42,2.42,0,0,1,208.54,289.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.49,289.17h0a2.42,2.42,0,0,1-2.42-2.42V256.48a2.42,2.42,0,0,1,2.42-2.42h0a2.42,2.42,0,0,1,2.42,2.42v30.27A2.43,2.43,0,0,1,311.49,289.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.24 287.32 207.04 287.32 207.04 266.34 210.04 266.34 210.04 284.32 310.24 284.32 310.24 266.34 313.24 266.34 313.24 287.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.08,99.83s0,.41,0,1.21,0,2,0,3.55c0,3.14,0,7.74.05,13.66,0,11.87.05,29,.08,50.22,0,42.41.05,101,.08,165.67,0,40.45,0,78.49,0,111.11v.19l-.19,0-87.84,15.71-24.71,4.39L199,466.71l-1.67.28-.57.08.56-.12,1.67-.32,6.51-1.2,24.7-4.51L318,445l-.19.23c0-32.62,0-70.66,0-111.11,0-64.69.06-123.26.08-165.67,0-21.2.06-38.35.08-50.22,0-5.92,0-10.52,0-13.66,0-1.55,0-2.74,0-3.55S318.08,99.83,318.08,99.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.79,467.07c0-2.33-.11-154-.25-367.24l.25.25H195l.26-.26c0,143.24-.06,273-.07,367.24l-.19-.18,155.76.18L195,467.26h-.19v-.19c0-94.24,0-224-.07-367.24v-.26h.29l155.73,0H351v.24C350.89,313,350.79,464.74,350.79,467.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.14,82.16c.1-.1,4.19,3.77,9.13,8.65s8.86,8.92,8.76,9-4.19-3.77-9.13-8.65S177,82.26,177.14,82.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.56,82.34c.1.1-3.57,4.1-8.2,8.93s-8.47,8.66-8.57,8.56,3.56-4.09,8.2-8.92S367.46,82.24,367.56,82.34Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.07,
    y: 21.51,
    width: 97.35,
    height: 48.78,
    rx: 6.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,70.29a7.19,7.19,0,0,0,2.74-.68,6.36,6.36,0,0,0,2.55-2.22,6.67,6.67,0,0,0,.87-2,9.4,9.4,0,0,0,.19-2.48c0-7.13-.05-17.42-.08-30.13,0-1.59,0-3.21,0-4.88a6.18,6.18,0,0,0-1.9-4.42,6.34,6.34,0,0,0-4.69-1.77h-5.51l-23.88,0-54.72,0a6.22,6.22,0,0,0-5.57,3.5,6.77,6.77,0,0,0-.63,3.37V46.16q0,6.87,0,13.47v3.29c0,.55,0,1.09,0,1.6a6.52,6.52,0,0,0,.36,1.51,6.24,6.24,0,0,0,4.45,3.87,14.84,14.84,0,0,0,3.07.15H248l20.81,0,30.12.08,8.19,0,2.13,0,.73,0-.73,0-2.13,0-8.19,0-30.12.08-20.81,0H227.24a15.53,15.53,0,0,1-3.17-.16,6.71,6.71,0,0,1-4.8-4.17,6.48,6.48,0,0,1-.4-1.63c-.05-.57,0-1.11,0-1.65V59.63q0-6.6,0-13.47v-14c0-1.18,0-2.37,0-3.56a7.42,7.42,0,0,1,.68-3.6,6.73,6.73,0,0,1,6-3.79l54.72,0,23.88,0h5.51a6.76,6.76,0,0,1,5,1.9,6.56,6.56,0,0,1,2,4.71v4.88c0,12.71-.07,23-.09,30.13a9,9,0,0,1-.22,2.52,6.34,6.34,0,0,1-.91,2,6.5,6.5,0,0,1-2.64,2.23,6.28,6.28,0,0,1-2.05.56C310.22,70.3,310,70.29,310,70.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.61,
    y: 25.84,
    width: 88.28,
    height: 40.11,
    rx: 2.11,
    style: {
      fill: "#A03525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.51,51.84v2.83H234V39.43h11.26v2.83H237.4v3.31h6.92v2.74H237.4v3.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.5,54.67l-3.6-5.29-3.53,5.29h-4l5.52-7.75-5.24-7.49h3.92L254,44.37l3.36-4.94h3.73l-5.2,7.36,5.56,7.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.84,39.43h3.45V54.67h-3.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.92,42.3h-4.78V39.43h13V42.3h-4.77V54.67h-3.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.66 48.07 287.66 44.04 298.74 44.04 293.19 38.5 299.24 38.5 306.79 46.06 299.11 53.74 293.45 53.74 298.65 48.32 287.66 48.07",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142,175.93c0,.14-12.2.26-27.26.26s-27.26-.12-27.26-.26,12.2-.26,27.26-.26S142,175.78,142,175.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.75,179.74c0,.15-8.79.26-19.62.26s-19.63-.11-19.63-.26,8.78-.26,19.63-.26S114.75,179.6,114.75,179.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.68,346.71c0,.14-8.42.26-18.81.26s-18.81-.12-18.81-.26,8.42-.26,18.81-.26S79.68,346.57,79.68,346.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.77,340.17c0,.14-5.74.26-12.81.26s-12.82-.12-12.82-.26,5.74-.26,12.82-.26S80.77,340,80.77,340.17Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.28,144.33l-9.18,1.11a28.52,28.52,0,1,1,4.48-9.18h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.28,144.33s-.08-.17-.27-.51l-.87-1.54c-.79-1.41-1.95-3.45-3.44-6.09a.12.12,0,0,0-.17-.05.12.12,0,0,0,0,.05h0l.23.1a28.47,28.47,0,0,0,.44-14.08,27.8,27.8,0,0,0-3.44-8.52,28.39,28.39,0,0,0-6.86-7.77,28.6,28.6,0,0,0-34.6-.56,28.13,28.13,0,0,0-8.8,10.49,27.84,27.84,0,0,0-3,13.41A29.21,29.21,0,0,0,72.8,142a28.72,28.72,0,0,0,37.55,12.5,28.29,28.29,0,0,0,10.85-9l-.09.05,6.87-.9,1.73-.24.57-.09s-.22,0-.62.06l-1.78.18-6.8.74-.08.05a28.28,28.28,0,0,1-50.32-22.78A29.09,29.09,0,0,1,73,116.12a28.18,28.18,0,0,1,42.56-9.8,27.92,27.92,0,0,1,6.79,7.62,27.48,27.48,0,0,1,3.44,8.37,28.44,28.44,0,0,1-.3,13.92.13.13,0,0,0,.09.16.13.13,0,0,0,.14-.06v0h-.22l3.54,5.94.92,1.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.78,115.88l-1.49,14.62A2.38,2.38,0,0,1,99,132.64h0a2.38,2.38,0,0,1-2.42-2.21l-1.06-14.8a1.87,1.87,0,0,1,2-2l3.58.19A1.87,1.87,0,0,1,102.78,115.88Z",
    style: {
      fill: "#A03525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.76,140.73a3.58,3.58,0,1,0,2.45-4.43A3.59,3.59,0,0,0,94.76,140.73Z",
    style: {
      fill: "#A03525"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147,423.34,130.6,448.26,169.52,471c1.94-3.85-13.83-23.08-13.83-23.08l8.65-13.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64,439.2a1.85,1.85,0,0,0-2.16,1.17,1.76,1.76,0,0,0,1.14,2.15,1.94,1.94,0,0,0,2.28-1.25,1.84,1.84,0,0,0-1.43-2.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,448.26l1.88-3.31,36.59,23.3s1.28,1.78.37,2.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.44,448.09c-.12.19-1.12-.28-2.41-.22s-2.26.57-2.39.4.79-1.11,2.36-1.16S156.58,447.94,156.44,448.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.53,452.16c-.06.21-1.07.06-2.19.48s-1.8,1.17-2,1.05.32-1.26,1.72-1.77S159.63,452,159.53,452.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,458.4c-.19-.06.1-1.16,1.2-1.92s2.22-.65,2.21-.44-.89.44-1.78,1.07S159.19,458.5,159,458.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.77,443.3c-.18.13-.9-.64-2-1.2s-2.15-.7-2.16-.92,1.2-.43,2.51.24S159,443.21,158.77,443.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.55,438.14c-.05.08-.87-.24-2-1.15a10.32,10.32,0,0,1-1.67-1.81,10.16,10.16,0,0,1-.77-1.25,2.47,2.47,0,0,1-.32-.8,1,1,0,0,1,.5-1.07,1.22,1.22,0,0,1,1.09.06,2.88,2.88,0,0,1,.67.52,8.43,8.43,0,0,1,1,1.13,8.11,8.11,0,0,1,1.11,2.23,3.86,3.86,0,0,1,.22,2.25c-.13,0-.22-.84-.73-2.07a9.24,9.24,0,0,0-1.17-2,8.51,8.51,0,0,0-.92-1c-.35-.35-.7-.56-.91-.44s-.1.08-.08.25a2.14,2.14,0,0,0,.23.59c.22.42.45.82.69,1.19A12.85,12.85,0,0,0,159,436.6C159.91,437.56,160.61,438,160.55,438.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.14,438.27a3.59,3.59,0,0,1,.58-2.18,7.4,7.4,0,0,1,1.52-2,6.84,6.84,0,0,1,1.19-.89,1.84,1.84,0,0,1,1.81-.26,1,1,0,0,1,.5,1,2.72,2.72,0,0,1-.22.83,4.79,4.79,0,0,1-.76,1.31,5.21,5.21,0,0,1-2,1.53c-1.35.56-2.28.33-2.26.25a16.92,16.92,0,0,0,2-.74,5.18,5.18,0,0,0,1.69-1.47,4.38,4.38,0,0,0,.62-1.15c.18-.44.22-.87,0-.92a1.33,1.33,0,0,0-1.05.24,7.69,7.69,0,0,0-1.1.78,8.05,8.05,0,0,0-1.52,1.72C160.47,437.47,160.26,438.3,160.14,438.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.46,428.29,26.19,450.15,60.81,479c2.56-3.48-9.82-25-9.82-25l10.78-12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.54,443.54a1.85,1.85,0,0,0-2.33.8,1.77,1.77,0,0,0,.77,2.31,2,2,0,0,0,2.46-.86,1.82,1.82,0,0,0-1.07-2.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.19,450.15l2.4-2.94,32.24,29s1,2-.12,2.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7,454.26c-.15.16-1.06-.46-2.34-.61s-2.32.19-2.42,0,1-1,2.52-.75S51.87,454.13,51.7,454.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.08,458.79c-.1.2-1.07-.13-2.24.11s-2,.85-2.13.71.53-1.2,2-1.46S54.21,458.62,54.08,458.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.52,464.86c-.19-.1.28-1.14,1.49-1.7s2.3-.27,2.26-.07-1,.28-1.93.76S52.7,465,52.52,464.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8,449.92c-.2.1-.78-.78-1.79-1.51s-2-1.05-2-1.27,1.25-.23,2.43.65S55,449.86,54.8,449.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4,445.13c-.06.07-.81-.38-1.73-1.46a10,10,0,0,1-1.35-2.07,10.3,10.3,0,0,1-.56-1.35,3.08,3.08,0,0,1-.18-.85,1,1,0,0,1,.67-1,1.23,1.23,0,0,1,1.07.23,3,3,0,0,1,.57.63,8.06,8.06,0,0,1,1.5,3.65,3.7,3.7,0,0,1-.16,2.26c-.12,0-.07-.86-.38-2.16a9,9,0,0,0-.82-2.16,7.62,7.62,0,0,0-.74-1.14c-.28-.4-.59-.66-.82-.58s-.11.06-.13.23a2.53,2.53,0,0,0,.14.62,12.28,12.28,0,0,0,.48,1.29,12.68,12.68,0,0,0,1.14,2C56.86,444.45,57.48,445,57.4,445.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,445.19c-.08,0,.09-.91.94-2.06a7.34,7.34,0,0,1,1.82-1.7,7.45,7.45,0,0,1,1.32-.68,1.86,1.86,0,0,1,1.84,0,1.08,1.08,0,0,1,.32,1.09,3.15,3.15,0,0,1-.35.78,4.91,4.91,0,0,1-1,1.17A5.17,5.17,0,0,1,59.65,445a2.88,2.88,0,0,1-2.26-.13,17.31,17.31,0,0,0,2.11-.39,5.26,5.26,0,0,0,1.9-1.18,4.55,4.55,0,0,0,.81-1c.25-.42.36-.83.19-.91a1.3,1.3,0,0,0-1.08.07,7.13,7.13,0,0,0-1.21.58,7.93,7.93,0,0,0-1.78,1.45C57.43,444.46,57.09,445.24,57,445.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.28,165.49l-4.82,39.69c-1,6.76-2.35,16.78,8.41,17.81h0c9.41.19,13-8.27,13.89-14.58.42-3,.78-5.49.84-5.8,0,0,10.26.49,12.41-9.43,1-4.79,2.38-14.83,3.49-23.93a18.91,18.91,0,0,0-15-20.79l-1-.19C180.09,146.76,173.49,155,172.28,165.49Z",
    style: {
      fill: "#ffcbb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.63,202.62a24.59,24.59,0,0,1-12.16-6.47s1.67,7.9,11.77,9Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.12,172.63c-.23,0-1.13-.86-2.7-1.49s-2.92-.67-3-.85.21-.19.8-.18a7.22,7.22,0,0,1,2.5.54,6.43,6.43,0,0,1,2.09,1.32C189.15,172.37,189.23,172.62,189.12,172.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.23,174.41a1.37,1.37,0,0,1-1.57,1.09,1.31,1.31,0,0,1-1.14-1.5,1.38,1.38,0,0,1,1.57-1.09A1.31,1.31,0,0,1,186.23,174.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.79,183.4a10.69,10.69,0,0,1,2.57.06c.4,0,.78,0,.9-.21a2,2,0,0,0,0-1.21c-.17-1-.36-2.09-.55-3.21-.74-4.55-1.19-8.27-1-8.3s.93,3.65,1.67,8.2c.17,1.12.34,2.19.49,3.22a2.28,2.28,0,0,1-.11,1.57,1,1,0,0,1-.75.44,2.9,2.9,0,0,1-.69-.05A9.89,9.89,0,0,1,191.79,183.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.44,164.11c.11-.4,1.49-.3,3.09-.6s2.87-.83,3.11-.5c.1.16-.1.54-.6.94a5.36,5.36,0,0,1-4.73.84C181.71,164.58,181.39,164.29,181.44,164.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.84,168.08c.22-.28,1.47.25,3,.53s2.93.26,3.05.6c.05.17-.25.4-.84.56a5.68,5.68,0,0,1-2.4,0,5.92,5.92,0,0,1-2.25-.91C199,168.54,198.74,168.21,198.84,168.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.57,173.16c-.16-.11-6.83-3.41-7.87,3.8s6.41,6.77,6.46,6.56S171.57,173.16,171.57,173.16Z",
    style: {
      fill: "#ffcbb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.35,180.47s-.14.07-.37.14a1.27,1.27,0,0,1-.94-.12,3.12,3.12,0,0,1-1-3,4.05,4.05,0,0,1,.61-1.75,1.44,1.44,0,0,1,1.08-.83.65.65,0,0,1,.69.45c.07.22,0,.36,0,.37s.17-.09.16-.4a.79.79,0,0,0-.22-.49,1,1,0,0,0-.67-.29,1.79,1.79,0,0,0-1.47.93,4.36,4.36,0,0,0-.73,1.95c-.16,1.46.39,2.92,1.39,3.38a1.36,1.36,0,0,0,1.17,0C168.31,180.64,168.37,180.49,168.35,180.47Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07,173.35c-.18.14-1.4-.13-3.07.14s-2.85.92-3,.84.08-.26.59-.55A7.35,7.35,0,0,1,201,173a6.53,6.53,0,0,1,2.46,0C204,173.12,204.16,173.28,204.07,173.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.66,176.67a1.37,1.37,0,0,1-1.57,1.09,1.31,1.31,0,0,1-1.14-1.49,1.37,1.37,0,0,1,1.57-1.1A1.31,1.31,0,0,1,200.66,176.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.24,162a1.67,1.67,0,0,0-.64-1,5,5,0,0,0-2.51-.75,14.66,14.66,0,0,1-6.07-2.38,7.17,7.17,0,0,0,2-1.06,4.33,4.33,0,0,0,1.79-4.12,1,1,0,0,0-.45-.72c-.43-.2-.87.19-1.23.5a3.72,3.72,0,0,1-3.67,1,6.09,6.09,0,0,1-2.51-1.1l-.07-.11c-.31-.41-.61-.81-.91-1.19h0c-2.25-2.89-4.24-4.94-6.4-6.16a23.45,23.45,0,0,0-12.31-2.58c-3.6.46-7.1,2.89-8.05,6.4-1.74-1.91-4.68-2.27-7.19-1.62l-.05,0c-2.78.6-4.65,3.21-5.78,5.82l-.18.43a10.61,10.61,0,0,1-4,3c-.27.11-.59.26-.66.55a.86.86,0,0,0,.36.76,5.24,5.24,0,0,0,2,1.17,11.54,11.54,0,0,1-1.12,1.75c-.36.47-.8,1-.6,1.59a1.13,1.13,0,0,0,1.1.67,3.44,3.44,0,0,0,1.31-.4l-1.16,2a6.37,6.37,0,0,0,2.91.18,63,63,0,0,0,1,7.38,4.13,4.13,0,0,1,2.72,1.05c.82,1,1,2.58,2.66,2.19.82-.21,1.75-1.76,2.12-2.53a39.52,39.52,0,0,0,3.84-16.34,12.59,12.59,0,0,1,4.24-2.3l-.13.09c2.93-.61,6.22-1.16,8.71.5,1.93,1.29,2.86,3.58,4.18,5.49a15,15,0,0,0,10.16,6.56c0,3.08-.81,6.87-1,9.71l3.2-4.21v0a10.87,10.87,0,0,0,.63-.93l.07-.1h0c.32-.5.62-1,1-1.5l0,0a1.78,1.78,0,0,0,2.88-2,4.37,4.37,0,0,0-.74-1,2.81,2.81,0,0,0,2.57,1,2.23,2.23,0,0,0,1.83-2,1.93,1.93,0,0,0-.92-1.64,6.35,6.35,0,0,0,3.68-.32C220.58,163.5,221.36,162.92,221.24,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.23,150.26a9.79,9.79,0,0,0-1.13.79,7.23,7.23,0,0,0-2,3.13,13.42,13.42,0,0,0-.58,2.51c-.12.93-.18,1.93-.24,3A28.31,28.31,0,0,1,179,163a11.86,11.86,0,0,1-.45,1.7,3.54,3.54,0,0,1-.93,1.59,1.49,1.49,0,0,1-1.47.29,2.23,2.23,0,0,1-1.18-.88,5.21,5.21,0,0,1-.64-2.67l.21.05A8.8,8.8,0,0,1,173,165a3,3,0,0,1-2.08.81,1.94,1.94,0,0,1-1-.31,1.69,1.69,0,0,1-.62-.79,1.8,1.8,0,0,1-.1-.91,1.27,1.27,0,0,1,.43-.74l.09.11a6.56,6.56,0,0,1-2.36,1.34,6.68,6.68,0,0,1-.7.17,1.51,1.51,0,0,1-.25,0l.24-.07a5.79,5.79,0,0,0,.68-.21,6.72,6.72,0,0,0,2.3-1.37l.09.11a1.31,1.31,0,0,0-.26,1.48,1.46,1.46,0,0,0,.56.7,1.74,1.74,0,0,0,.91.27,2.8,2.8,0,0,0,1.94-.78,8.29,8.29,0,0,0,1.45-1.9l.18-.3,0,.35a5.07,5.07,0,0,0,.61,2.56,2.07,2.07,0,0,0,1,.79,1.28,1.28,0,0,0,1.26-.25,3.46,3.46,0,0,0,.86-1.49,12.46,12.46,0,0,0,.44-1.67,25.52,25.52,0,0,0,.36-3.27c.07-1.05.13-2.05.27-3a12.21,12.21,0,0,1,.62-2.55A7.1,7.1,0,0,1,182,151,4.13,4.13,0,0,1,183.23,150.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,164l-.09.05-.27.15a2.85,2.85,0,0,1-.46.22,5.29,5.29,0,0,1-.65.24,8.91,8.91,0,0,1-4.4.22,11.39,11.39,0,0,1-5.76-3,19.78,19.78,0,0,1-4.42-6.66c-.58-1.31-1-2.63-1.52-3.87a13.42,13.42,0,0,0-1.84-3.34,6.92,6.92,0,0,0-2.67-2.13,4.78,4.78,0,0,0-1.5-.37,5.17,5.17,0,0,0-1.43.09,5.74,5.74,0,0,0-2.25,1,5.48,5.48,0,0,0-1.32,1.32,6.14,6.14,0,0,0-.71,1.44s0,0,0-.11l.08-.3a5.18,5.18,0,0,1,.53-1.08,5.79,5.79,0,0,1,1.32-1.38,5.89,5.89,0,0,1,2.3-1,5.5,5.5,0,0,1,1.48-.11,5.21,5.21,0,0,1,1.56.37,7.13,7.13,0,0,1,2.76,2.18,13.56,13.56,0,0,1,1.89,3.39c.51,1.24,1,2.56,1.51,3.85a20,20,0,0,0,4.36,6.61,11.42,11.42,0,0,0,5.65,3,9.2,9.2,0,0,0,4.33-.14C212.48,164.31,213,164,213,164Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.47,159.74a1.91,1.91,0,0,1-.39.2,7.67,7.67,0,0,1-1.13.4,10.38,10.38,0,0,1-1.76.34,12.27,12.27,0,0,1-2.19,0,12.14,12.14,0,0,1-2.16-.43,10.2,10.2,0,0,1-1.66-.67,7.76,7.76,0,0,1-1-.61c-.23-.17-.36-.26-.35-.28s.54.32,1.46.74a12.14,12.14,0,0,0,1.65.61,12.56,12.56,0,0,0,2.11.4,12.9,12.9,0,0,0,2.15,0,12,12,0,0,0,1.74-.28C213.88,160,214.46,159.7,214.47,159.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.43,357.07c-2.05-3-4.8-6.78-8.44-11.2-6.22-7.56-15.12-17-18.91-21-4.15-5.12-15.39-21-19.22-25.41C151,293.87,143,288.6,143,288.6L95.4,293.87l-3,2.79c.64,3.84,2.65,16,6.91,21.53,5.21,6.73,18.89,19.11,25.62,21.06a115.51,115.51,0,0,1,12.59,4.63c7.55,5.22,32.68,22.71,34.65,25.54a.76.76,0,0,1,0,1s-10,10.36-14.9,20.72C151.46,403.3,138,431,138,431l23.89,12.21s30.49-49.25,34.53-55.42c1.59-2.42,4.66-8.45,7.19-13.56A17.06,17.06,0,0,0,202.43,357.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.69,310l-35.12-12.12s.84,14.71,3,18.43l-22.19,49S66.49,395,60.25,403c-8.09,10.5-21.35,32.34-21.35,32.34l19.41,14.14,48.13-57.32s5.32-2.32,7.25-5.42l36.49-45.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,228.07l-.8-6.78,3.84-4.71s4.14-2.34,4.66-3a1.76,1.76,0,0,1,.45,1.79s1.33-1.69,2.21-1.6,1.48,1.62,1.71,2.68a6.73,6.73,0,0,1,1.77,1.17,3.59,3.59,0,0,1,1.08,1.82l-.24,1.36a1.66,1.66,0,0,1,1.65.83,5,5,0,0,1,.32,2.52s1.06-.58,1.56.27a2.26,2.26,0,0,1,.42,2.08c-.22.73-3.62,6.43-4.79,7.32S252,242.3,252,242.3l-8.43-8.84Z",
    style: {
      fill: "#ffcbb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.4,226.8a6.58,6.58,0,0,1-1.46,1.65,16.64,16.64,0,0,1-1.9,1.47,2.38,2.38,0,0,1-1.42.5,1.63,1.63,0,0,1-1.38-.91,1.72,1.72,0,0,1,.12-1.65,4.11,4.11,0,0,1,1-1,23.71,23.71,0,0,1,2-1.33,7.47,7.47,0,0,1,2-1s-.7.47-1.81,1.23c-.56.37-1.21.84-1.9,1.39a3.77,3.77,0,0,0-.93.94,1.27,1.27,0,0,0-.08,1.24,1.2,1.2,0,0,0,1,.68,2,2,0,0,0,1.17-.42,21.29,21.29,0,0,0,1.92-1.36C265.78,227.37,266.35,226.76,266.4,226.8Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.34,216.53c.05.05-.66.64-1.69,1.71a24.65,24.65,0,0,0-1.71,1.95c-.31.38-.61.79-.92,1.23a2.42,2.42,0,0,1-1.41,1.08,1.28,1.28,0,0,1-1-.18,1.61,1.61,0,0,1-.56-.74,2.14,2.14,0,0,1,.12-1.66,8.32,8.32,0,0,1,.73-1.23l.69-1a13.18,13.18,0,0,1,1.44-1.94,13.41,13.41,0,0,1-1.18,2.11,23.36,23.36,0,0,0-1.31,2.22,1.74,1.74,0,0,0-.09,1.34.92.92,0,0,0,1.05.66,2.16,2.16,0,0,0,1.15-.91c.31-.43.63-.85.95-1.23a20.5,20.5,0,0,1,1.8-1.92A8.7,8.7,0,0,1,261.34,216.53Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.33,220.44c0,.05-.5.49-1.27,1.29a17.64,17.64,0,0,1-3.24,3,10,10,0,0,1-1.08.7,1.12,1.12,0,0,1-.71.11,2,2,0,0,1-.57-.29,1.49,1.49,0,0,1-.45-.42,3.82,3.82,0,0,1-.23-.51,2.37,2.37,0,0,1-.1-1,2.39,2.39,0,0,1,.49-1.28c.2-.26.36-.34.38-.33a3.28,3.28,0,0,0-.56,1.63,2.15,2.15,0,0,0,.14.84,1.77,1.77,0,0,0,.21.41,1,1,0,0,0,.34.3,1.59,1.59,0,0,0,.44.21.64.64,0,0,0,.44-.08,8.88,8.88,0,0,0,1-.68,23,23,0,0,0,3.29-2.83A4.6,4.6,0,0,1,263.33,220.44Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.59,223.89a15,15,0,0,1-2,1.59l-2.28,1.63a6.09,6.09,0,0,1-1.47.88,1.75,1.75,0,0,1-1,0,1.18,1.18,0,0,1-.78-.7,2,2,0,0,1,.32-1.88c.36-.49.73-.88,1.09-1.29a20.08,20.08,0,0,1,2-2,11.42,11.42,0,0,1,1.56-1.1c.39-.22.63-.31.64-.28s-.83.54-2,1.61a23.65,23.65,0,0,0-1.92,2c-.34.4-.72.82-1,1.26a1.54,1.54,0,0,0-.28,1.47,1,1,0,0,0,1.24.44,5.77,5.77,0,0,0,1.37-.8l2.34-1.55A15,15,0,0,1,265.59,223.89Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.25,215.23c.15.06-.67,1.84-2.26,3.61-.2.22-.4.43-.61.62a3.5,3.5,0,0,1-.31.27.94.94,0,0,1-.1.1.19.19,0,0,0,0,.1,7,7,0,0,1-.09,1.33,2.29,2.29,0,0,1-.45,1.19,11.15,11.15,0,0,1,.14-1.23,11.7,11.7,0,0,0,0-1.35.7.7,0,0,1,.08-.26l.18-.18.29-.28a8.28,8.28,0,0,0,.58-.6,28.93,28.93,0,0,0,1.85-2.32A7.25,7.25,0,0,1,257.25,215.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,225.5c-.07,0-.18-.28-.5-.67a18.89,18.89,0,0,0-1.38-1.44,4.42,4.42,0,0,0-1.65-1c-.48-.14-.8-.12-.81-.19s.32-.19.87-.11a3.66,3.66,0,0,1,1.88,1,7.43,7.43,0,0,1,1.34,1.59C256.06,225.13,256.08,225.49,256,225.5Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,249.44s.65,5.51.37,7.13-2,6.6-1.76,8.84a1.35,1.35,0,0,1-2.15-.9,15.43,15.43,0,0,1-.3-6.18c.3-1.34-.73-1.45-1.48-.78s-5.05,6-5.05,6-4,6.75-5,6.92-1.36-1-1.56-1.48,3-6.57,3-6.57l2.05-2.81s-7,8.4-8.07,8.49a1.19,1.19,0,0,1-1.39-1.31c0-.65,3.11-4.32,3.11-4.32l3.85-5.24-8.67,8.59s-.93.71-1.59.08-.11-2-.11-2l8.17-9.66s-9.2,1.91-9.63,1.5-.9-1.1-.39-1.37,10.18-4.24,10.18-4.24l8.38-6.32,2.21-1.66,7,5.92Z",
    style: {
      fill: "#ffcbb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,241.24,79.29,209A15.53,15.53,0,0,1,91,202.62l41.21-2.15s5.92-7.11,9.44-6.38,9,4.31,7.48,10.85S138.71,224.77,128.4,226l-34.61-.1L69.88,250.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.62,293.07l20.24,6.37c2.61-2.77,9.51-18.34,9.51-18.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.84,197.58l-23-2.41-12.33,28.15-10.07,41.77s-33.59,20.25-40.14,29c-3.29,4.37,6.8,15.65,6.8,15.65s10.45,15.17,20.48,13.3,32.79-18.68,44.1-26.85c3.34-2.4,9.24-6.76,12.88-12.1a67.45,67.45,0,0,0,8.33-18.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.67,208.73l10.65,12.06c.51.87-7.87,30.74-11.82,38.17-1.53,2.89-12.51,15.38-18.3,26V318.2l-14.34-18.76,2.19-3.21,13.81-30.71,18.72-21.89L190,223.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.84,241.45l-25.51-15.7-2-5-12.56,36.39s36.42,9,43.62,5.78,28.34-22.34,28.34-22.34l-13-12.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.84,197.58l2.33-3.16A90.11,90.11,0,0,1,178,205.53a107.18,107.18,0,0,1,6.67,10.59l5.27-7,.69,34.52-18.72,21.89-6.79-65.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,262.13a3.23,3.23,0,0,1-.22-.65c-.13-.48-.3-1.11-.52-1.89-.45-1.64-1.16-4-2.07-6.9s-2-6.36-3.26-10.18-2.57-8-3.72-12.57a50.9,50.9,0,0,1-1.33-6.68,16.44,16.44,0,0,1,.59-6.34c1.15-3.91,3.08-7,4.37-9.78a26.55,26.55,0,0,0,2.44-6.72c.07-.41.13-.78.19-1.11s0-.58.06-.82a3.2,3.2,0,0,1,.09-.68,3.67,3.67,0,0,1,0,.69c0,.24,0,.51,0,.83s-.09.71-.14,1.13a25,25,0,0,1-2.31,6.84c-1.25,2.78-3.14,5.92-4.24,9.75a16.13,16.13,0,0,0-.54,6.16,51.58,51.58,0,0,0,1.33,6.61c1.13,4.49,2.46,8.71,3.66,12.55s2.3,7.29,3.17,10.21,1.52,5.3,1.91,7c.21.83.33,1.48.43,1.92A6.62,6.62,0,0,1,167,262.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.82,256.47a4.66,4.66,0,0,1,.17-1.13c.17-.82.38-1.84.63-3,.52-2.55,1.19-6.1,1.74-10s.89-7.53,1.09-10.13c.09-1.21.17-2.24.24-3.08a4.2,4.2,0,0,1,.14-1.13,5.6,5.6,0,0,1,.06,1.13c0,.74,0,1.79-.07,3.1-.11,2.62-.39,6.23-.94,10.18s-1.28,7.51-1.9,10c-.31,1.27-.58,2.3-.79,3A6,6,0,0,1,127.82,256.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.75,249.55c-.13.07-1.35-1.89-3.08-4.14s-3.3-3.95-3.19-4.06a22.65,22.65,0,0,1,6.27,8.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.34,241.24a14.89,14.89,0,0,1-9.5-3.74c.09-.13,2,1.21,4.61,2.23S139.36,241.08,139.34,241.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.71,269.17s-.13.11-.4.28-.68.42-1.22.69a32.51,32.51,0,0,1-4.74,2.05,35.34,35.34,0,0,1-16.84,1.52,37,37,0,0,1-15.66-6.43,36.47,36.47,0,0,1-4-3.28c-.44-.41-.76-.77-1-1a2,2,0,0,1-.32-.37,14.2,14.2,0,0,1,1.44,1.22,45.34,45.34,0,0,0,4.06,3.12,38.26,38.26,0,0,0,15.53,6.23,36.43,36.43,0,0,0,16.65-1.36A40.21,40.21,0,0,0,167,270,16.36,16.36,0,0,1,168.71,269.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.65,276.38a4.25,4.25,0,0,1-.72.66c-.48.4-1.22.95-2.15,1.58a38.19,38.19,0,0,1-7.8,4,36.44,36.44,0,0,1-8.53,2.11,25.58,25.58,0,0,1-2.66.21,3.33,3.33,0,0,1-1,0c0-.09,1.38-.18,3.59-.53a43.76,43.76,0,0,0,8.39-2.23,45.84,45.84,0,0,0,7.79-3.85C163.48,277.13,164.59,276.31,164.65,276.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.67,286.93c-.15,0-.16-2.25-.58-5s-1.05-4.88-.91-4.92a13.32,13.32,0,0,1,1.43,4.84A13.75,13.75,0,0,1,169.67,286.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.09,223.92a47,47,0,0,0,3.64-3,22.52,22.52,0,0,0,6.4-20.76c-.58-2.86-1.4-4.5-1.3-4.54a5.38,5.38,0,0,1,.59,1.14,19.7,19.7,0,0,1,1.07,3.32,21.82,21.82,0,0,1-6.51,21.1,19.62,19.62,0,0,1-2.76,2.14A4.7,4.7,0,0,1,136.09,223.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,284.92a3.77,3.77,0,0,1,.34-.63c.24-.4.58-1,1.06-1.75.94-1.51,2.35-3.67,4.11-6.31,3.5-5.3,8.5-12.53,13.37-20.9.62-1,1.19-2.09,1.74-3.13s1.08-2.07,1.59-3.09.92-2.06,1.37-3.06c.23-.49.37-1,.56-1.51s.38-1,.49-1.5a26.09,26.09,0,0,0,.78-5.85,47.9,47.9,0,0,0-.11-5.17c-.23-3.16-.61-5.71-.85-7.46-.12-.84-.21-1.52-.28-2a3.81,3.81,0,0,1-.07-.71,2.86,2.86,0,0,1,.17.69c.09.51.22,1.18.38,2,.3,1.75.74,4.29,1,7.47a47.88,47.88,0,0,1,.17,5.21,25.53,25.53,0,0,1-.75,6,16,16,0,0,1-.49,1.53c-.19.51-.33,1.05-.56,1.55-.45,1-.84,2.07-1.37,3.09s-1,2.08-1.59,3.12-1.13,2.1-1.75,3.14c-4.88,8.4-9.94,15.59-13.51,20.85-1.77,2.58-3.22,4.69-4.25,6.21l-1.14,1.7A3.69,3.69,0,0,1,170.2,284.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.27,231a14.49,14.49,0,0,1-.93,2.74c-.65,1.66-1.61,3.94-2.74,6.42s-2.23,4.69-3.06,6.28a15.92,15.92,0,0,1-1.46,2.5,15.91,15.91,0,0,1,1.13-2.67c.81-1.77,1.81-3.93,2.92-6.32s2.06-4.58,2.87-6.35A17.37,17.37,0,0,1,201.27,231Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.86,237.7a21,21,0,0,1-2,2c-1.27,1.2-3,2.9-4.76,4.9s-3.25,3.9-4.29,5.31a21.55,21.55,0,0,1-1.72,2.26,12.17,12.17,0,0,1,1.42-2.47,51.12,51.12,0,0,1,4.2-5.45,50,50,0,0,1,4.91-4.82A12.44,12.44,0,0,1,204.86,237.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.37,252.72a48.14,48.14,0,0,1-2-9.7,46,46,0,0,1,2,9.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.61,251.66c-.15,0-.71-2.19-1.63-4.86s-1.85-4.76-1.71-4.83a23.67,23.67,0,0,1,3.34,9.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.41,214.61a28.78,28.78,0,0,1,6.13,11.17c-.15.06-1.2-2.6-2.9-5.68S88.29,214.7,88.41,214.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.34,211.49a40.16,40.16,0,0,1,2,6.16,40.14,40.14,0,0,1,1.47,6.3,40.16,40.16,0,0,1-2-6.16A40.14,40.14,0,0,1,91.34,211.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.06,278.46a8.13,8.13,0,0,1,1.54-.23l4.19-.47c3.54-.41,8.42-1,13.78-1.92s10.19-1.87,13.67-2.63l4.12-.9a9.88,9.88,0,0,1,1.53-.28,8.77,8.77,0,0,1-1.48.48c-1,.27-2.36.64-4.09,1.06-3.46.85-8.29,1.89-13.66,2.78s-10.28,1.46-13.83,1.77c-1.78.16-3.22.26-4.21.31A10.31,10.31,0,0,1,126.06,278.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.1,265.09a23.53,23.53,0,0,1,3,1c1.85.62,4.42,1.43,7.3,2.2s5.51,1.34,7.43,1.73a26.28,26.28,0,0,1,3.09.68,15.28,15.28,0,0,1-3.16-.32,70.72,70.72,0,0,1-7.49-1.58,72.55,72.55,0,0,1-7.29-2.37A16.31,16.31,0,0,1,141.1,265.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "124.56 292.57 115.97 296.94 99.88 280.55 108.89 277.97",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.89,278a2.26,2.26,0,0,1-.63.25l-1.81.58-6.51,2,.09-.36,8.17,8.26,7.93,8.13-.26,0,6.28-3.09,1.77-.83a2.77,2.77,0,0,1,.64-.26,2.82,2.82,0,0,1-.58.38l-1.72.93-6.19,3.26-.14.07-.12-.11-8-8.08-8.11-8.32-.26-.26.36-.1,6.57-1.78,1.84-.46A3,3,0,0,1,108.89,278Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56,292.57a78.71,78.71,0,0,1-6.76-6,80.15,80.15,0,0,1-6.4-6.42,77,77,0,0,1,6.76,6A78.16,78.16,0,0,1,124.56,292.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,272.1l.27,0a1.66,1.66,0,0,0-2.21,1.05,1.78,1.78,0,0,0,1.29,2.16,1.74,1.74,0,0,0,1.91-1.6A1.67,1.67,0,0,0,169,272.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.05,290c-.06-.06,1.14-1.17,2.74-3.26a68.39,68.39,0,0,0,9.65-18c.85-2.48,1.1-4.09,1.19-4.08a4.24,4.24,0,0,1-.11,1.14,24.86,24.86,0,0,1-.73,3.05,53.53,53.53,0,0,1-4,9.51,52.88,52.88,0,0,1-5.68,8.62,23,23,0,0,1-2.13,2.3A4.6,4.6,0,0,1,158.05,290Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.48,394.87a2.53,2.53,0,0,1,.22-.53c.18-.37.41-.87.72-1.5.64-1.32,1.63-3.22,3-5.57s3.14-5.14,5.35-8.19c1.11-1.53,2.32-3.12,3.66-4.75.68-.81,1.37-1.64,2.11-2.46l1.13-1.24a3.82,3.82,0,0,0,.52-.6c.1-.2,0-.31-.11-.4l0,0,0-.05a37.56,37.56,0,0,0-4.42-3.83c-1.61-1.25-3.29-2.51-5-3.79-3.47-2.57-7.14-5.2-10.94-7.89-5-3.53-9.78-6.89-14.22-10l.05,0c-2.68-1.09-5-2.62-7.38-3.71a39.21,39.21,0,0,0-7.11-2.31,27.19,27.19,0,0,1-11-5.74,43.69,43.69,0,0,1-5.68-5.86c-.6-.74-1-1.33-1.31-1.74l-.32-.46c-.07-.11-.1-.16-.09-.17l.13.14c.09.12.2.27.34.44.31.39.76,1,1.37,1.69a48.18,48.18,0,0,0,5.76,5.72,26,26,0,0,0,4.71,3.19,29.08,29.08,0,0,0,6.2,2.38,39.37,39.37,0,0,1,7.2,2.3c2.42,1.1,4.74,2.61,7.37,3.67h0l0,0c4.45,3.05,9.27,6.4,14.24,9.93,3.8,2.7,7.48,5.34,10.94,7.91,1.73,1.29,3.41,2.56,5,3.81a35.63,35.63,0,0,1,4.49,3.95l-.09-.08a.78.78,0,0,1,.41.46.82.82,0,0,1-.09.59,4.2,4.2,0,0,1-.58.69c-.39.41-.76.82-1.14,1.23-.74.81-1.43,1.63-2.11,2.43-1.35,1.61-2.56,3.2-3.69,4.7-2.22,3-4,5.79-5.41,8.11s-2.43,4.2-3.1,5.49l-.78,1.48A3,3,0,0,1,155.48,394.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.19 214.5 183.48 214.42 183.48 214.42 182.04 216.76 183.03 219.24 185.69 219.59 187.2 216.4 186.19 214.5",
    style: {
      fill: "#A03525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.68,217,178,214.35s1.65-2.79,5.64,0Z",
    style: {
      fill: "#A03525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.6,214.35a3.56,3.56,0,0,1-.79-.44,4.28,4.28,0,0,0-2.3-.65,3.43,3.43,0,0,0-1.57.54,8.43,8.43,0,0,0-1.54,1.28,27.3,27.3,0,0,1-3.51,3.4l-.31.22-.07-.38a35.93,35.93,0,0,0-1.46-5.08,109.33,109.33,0,0,0-5-11.21c-.67-1.34-1.23-2.46-1.66-3.34a7.29,7.29,0,0,1-.56-1.26,6.31,6.31,0,0,1,.73,1.16c.44.77,1.07,1.88,1.81,3.27a85.67,85.67,0,0,1,5.16,11.2,36.23,36.23,0,0,1,1.46,5.17l-.39-.16a29.25,29.25,0,0,0,3.49-3.29,8.56,8.56,0,0,1,1.65-1.3,3.84,3.84,0,0,1,1.75-.53,4.16,4.16,0,0,1,2.4.82A4.76,4.76,0,0,1,183.6,214.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.89,216.9c.05,0,.09.43-.18,1.09a3.75,3.75,0,0,1-1.94,2l-.36.16v-.41c0-.29,0-.6,0-.91a14.85,14.85,0,0,0-1.23-4.4c.05,0,.43.35.84,1.11a8,8,0,0,1,.91,3.26,7.85,7.85,0,0,1,0,1l-.35-.25a3.83,3.83,0,0,0,1.84-1.65C189.73,217.28,189.82,216.88,189.89,216.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.6,218.27a3.07,3.07,0,0,1,0,.5c0,.38-.11.84-.18,1.4-.16,1.22-.43,3-.78,5.13-.71,4.33-1.78,10.3-3.32,16.82a145.67,145.67,0,0,1-4.88,16.44c-.76,2.06-1.43,3.71-1.93,4.83l-.58,1.29c-.14.29-.22.44-.24.43a2.06,2.06,0,0,1,.14-.48c.13-.35.3-.79.49-1.32.45-1.14,1.06-2.8,1.77-4.87,1.44-4.14,3.18-9.94,4.73-16.44s2.66-12.45,3.46-16.76c.38-2.09.7-3.82.94-5.1.11-.56.2-1,.27-1.39A1.69,1.69,0,0,1,183.6,218.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.37,218.73c-1.65,1.45-2.62,3.54-4.18,5.08-3.73,3.67-9.79,3.41-14.83,2s-10-3.76-15.22-3.43c-6,.38-11.09,4.16-15.84,7.79-2.44,1.86-5.29,3.48-7.73,5.34l-2.4,9.83c4,1,8.52-1.81,11.41-4.81s5.29-6.6,8.9-8.65,7.79-2.27,11.83-1.88,8,1.35,12.05,1.64,8.32-.19,11.69-2.43S185.61,222.59,184.37,218.73Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M182,216.76c.45,1.75-1.18,2.66-2.72,3.59s-4,.79-5.76.66c-8.67-.61-15.73-7.43-24.4-8.12-6-.48-12.42,2.4-17.57,5.57S122,225.85,117,229.29c-11.89,8.21-14.57,7-26.42,9.25l-3.82,8.88,10,2.48s23.89-6.25,31.45-14c7.71-7.87,12-14.82,17.62-16.22,11.9-3,24.71,7.12,31.82,5.67a11.44,11.44,0,0,0,8.6-7.12Z",
    style: {
      fill: "#A03525"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "102.7 283.43 98.21 284.92 112.22 299.46 123.15 293.3 116.17 296.37 102.7 283.43"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.82,275.45c-10.1,5.13-21.7,6.24-33,7.27,9.61,2.2,23.24.32,33-7.27"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M190.62,187a6.25,6.25,0,0,0-1.48-.8,2.14,2.14,0,0,0-1.65.08,2.91,2.91,0,0,0-1.32,2.37c1.11,1.54,2.13,1.6,3.83,1.54a14.37,14.37,0,0,0,.78-3",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.11,190.38a2.29,2.29,0,0,1-1.61.07,4.29,4.29,0,0,1-1.63-.73,2.65,2.65,0,0,1-.77-.79,1.4,1.4,0,0,1-.07-1.26,3.08,3.08,0,0,1,1.53-1.64,2.35,2.35,0,0,1,1.83,0c1,.42,1.29,1,1.25,1a10.56,10.56,0,0,0-1.37-.68,2.1,2.1,0,0,0-1.51.08,2.68,2.68,0,0,0-1.24,1.38c-.29.61.15,1.11.64,1.49a4.48,4.48,0,0,0,1.44.76C189.49,190.37,190.11,190.29,190.11,190.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.58,257.85a2.18,2.18,0,0,1,.38,0l1.11.18,4.25.77L212,261.66c3.31.55,6.93,1.2,10.83,1.66a23.81,23.81,0,0,0,6,.1c2.05-.3,3.89-1.49,5.78-2.63a55.21,55.21,0,0,0,5.51-3.93c1.83-1.43,3.66-2.94,5.51-4.48,3.71-3.08,7.5-6.33,11.36-9.69l2.58-2.26v.38l-13-12.19.32,0-18.9,13-.11.08-.11-.07-18.54-11.52-5.09-3.2-1.33-.86c-.3-.19-.44-.3-.44-.3a5.28,5.28,0,0,1,.47.25l1.36.8,5.16,3.11L228,241.27h-.23l18.84-13,.17-.12.15.14,13,12.17.21.2-.22.19-2.58,2.26c-3.86,3.36-7.66,6.61-11.37,9.7-1.86,1.53-3.69,3-5.53,4.47a56.63,56.63,0,0,1-5.57,3.95c-1.89,1.13-3.79,2.35-6,2.68a24.25,24.25,0,0,1-6.16-.13c-3.92-.48-7.54-1.15-10.84-1.73-6.6-1.19-11.93-2.24-15.61-3l-4.23-.86L191,258Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.91b830b59aab93271cc4037c2eb910e6.svg";
export { ForwardRef as ReactComponent };